import ProfileChangeLogIcon from '@material-ui/icons/ViewList';

import ProfileChangeLogReadyList from './ProfileChangeLogReadyList';

export default {
  list: ProfileChangeLogReadyList,
  icon: ProfileChangeLogIcon,
};
